// src/api/campaignApi.ts
import axios from 'axios';
import config from '../config';
import { store } from '../store/store';

/**
 * Dedicated axios instance for the owner-only e-mail campaign screen.
 *
 * Same reasoning as `invoicingApi`: the shared `api` instance dispatches `logout()` on ANY 403
 * (see api/axiosInstance.ts), and this screen answers 403 for reasons that have nothing to do with
 * an expired session. Being signed out of the whole site part-way through a send would be a
 * genuinely bad outcome — the send is resumable, but only if you can still reach the page.
 */
const campaignApi = axios.create({
    baseURL: config.API_URL,
});

campaignApi.interceptors.request.use(
    (requestConfig) => {
        const token = store.getState().auth.accessToken;
        if (token) {
            requestConfig.headers.Authorization = `Bearer ${token}`;
        }
        return requestConfig;
    },
    (error) => Promise.reject(error)
);

export default campaignApi;
